import MathHtml from 'components/imported-assessment/MathHtml'
import update from 'immutability-helper'
import {difference} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'
import StatusIcon from '../StatusIcon'

const useStyles = makeStyles(multipleChoiceStyles)

export default function MultipleChoice ({context, question}) {

  const classes = useStyles()
  const {quizAssessmentResults: assessment, translate} = context
  const {properties: {singleOption}} = question

  const {choices = []} = question.answer

  const Choices = singleOption ? RadioChoice : CheckboxChoice

  return (
    <Box className={classes.root}>
      {choices.length > 0 && (
        <Choices
          question={question}
          context={context} 
          choices={choices}
          answer={assessment.answers[question.id]}
        />)}
    </Box>
  )
}

function RadioChoice ({context, choices, answer}) {

  const classes = useStyles()
  const correctChoice = choices.find(c => c.correct) || {}

  return (
    <RadioGroup className={clsx("choices", "radio")} value={answer.selected}>
      {choices.map((choice, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <Box key={index} className={classes.option}>
            <StatusIcon value={choice.id} answer={answer.selected} correctAnswer={correctChoice.id} />
            <Box className={classes.index}>{answerIndex})</Box>
            <Box className={classes.radio}>
              <FormControlLabel
                value={choice.id}
                className="choice"
                control={<Radio color="primary" />}
                label={context.importedMath ? <MathHtml className="choice-caption" html={choice.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: choice.html || ''}} />}
              />
            </Box>
          </Box>
        )
      })}
    </RadioGroup>
  )
}

function CheckboxChoice ({context, question, choices, answer}) {

  const classes = useStyles()

  const {assessment} = context

  const correct = difference(choices.filter(c => c.correct).map(c => c.id), answer.selectedOptions).length == 0

  return (
    <FormGroup className={clsx("choices", "checkbox")}>
      {choices.map((option, index) => {

        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        const checked = answer.selectedOptions.indexOf(option.id) >= 0

        return (
        <Box key={index} className={classes.option}>
          <StatusIcon value={option.id} answer={checked && option.id} correctAnswer={option.correct && option.id} />
          <Box className={classes.index}>{answerIndex})</Box>
          <Box className={classes.checkbox}>
            <FormControlLabel
              control={<Checkbox color="primary" checked={checked} />}
              label={context.importedMath ? <MathHtml className="choice-caption" html={option.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: option.html || ''}} />}
            />
          </Box>
        </Box>
        )})}
    </FormGroup>
  )
}

function multipleChoiceStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      fontSize: '12pt',
    },
    index: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginRight: 6,
    },
    incorrect: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      visibility: 'hidden',
      color: "#fff",
      marginRight: 10,
      '& svg': {
        fill: '#f30d2a'
      },
      '&.visible': {
        visibility: 'visible'
      }
    },
    correct: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '& svg': {
        fill: '#27bc58',
      },
      marginRight: 10 ,
      visibility: 'hidden',
      '&.visible': {
        visibility: 'visible'
      }
    },
    option: {
      display: 'flex'
    }
  }
}
